import { useSelector } from 'react-redux';
import { getCurrentUserHasCore } from '@wix/da-shared-react/pkg/publicSession/selectors';
import {
  getCanSubmitFreePrompts,
  getCanSubmitPaidPrompts,
} from '@wix/da-dreamup/pkg/redux/form/selectors';

/**
 * Indicates what we'll ask the user to do to confirm their desired {@link SpendConfirmationAction}.
 */
export enum SpendType {
  SubmitWithPrompt = 'submit-with-prompt',
  SubmitWithPoints = 'submit-with-points',
  UpgradeToCore = 'upgrade-to-core',
  PurchasePoints = 'purchase-points',
}

/**
 * Returns an enum indicating the price we ask when the confirmation modal's
 * confirm button is clicked.
 *
 * e.g. do we ask the user to spend a prompt? some points?
 */
export function useSpendType(): SpendType {
  const hasCore = useSelector(getCurrentUserHasCore);
  const canSubmitPaidPrompts = useSelector(getCanSubmitPaidPrompts);
  const canSubmitFreePrompts = useSelector(getCanSubmitFreePrompts);

  if (canSubmitFreePrompts) {
    return SpendType.SubmitWithPrompt;
  }

  if (!hasCore) {
    return SpendType.UpgradeToCore;
  }

  if (canSubmitPaidPrompts) {
    return SpendType.SubmitWithPoints;
  }

  return SpendType.PurchasePoints;
}
